var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { FctParam } from './Fct';
import { Approve } from './plugins/ERC20/actions/approve';
import { liquidity_method, method } from './plugins/FCT_UNISWAP/constants';
import * as plugins from './pluginsExport';
export var getOutputValues = function (_a) {
    var plugin = _a.plugin, provider = _a.provider, execute = _a.execute, walletSigner = _a.walletSigner, withAutoApprovals = _a.withAutoApprovals;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(withAutoApprovals && plugin.protocol !== 'KIROBO_MULTICALL_CSV')) return [3 /*break*/, 2];
                    return [4 /*yield*/, setPluginApprovals({ plugin: plugin, provider: provider, walletSigner: walletSigner })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    if (!(plugin.method === 'addLiquidity_noMinProtection' || plugin.method === 'addLiquidityTo_noMinProtection')) return [3 /*break*/, 4];
                    return [4 /*yield*/, getSimpleAddLiquidityOutputValues({
                            plugin: plugin,
                            provider: provider,
                            execute: execute,
                        })];
                case 3: return [2 /*return*/, _b.sent()];
                case 4:
                    if (!(plugin.method === 'swap_noSlippageProtection' || plugin.method === 'swapTo_noSlippageProtection')) return [3 /*break*/, 6];
                    return [4 /*yield*/, getSwapNoSlippageProtectionOutputValues({
                            plugin: plugin,
                            provider: provider,
                            execute: execute,
                        })];
                case 5: return [2 /*return*/, _b.sent()];
                case 6: return [4 /*yield*/, plugin.getOutputValues({ provider: provider, execute: execute, walletSigner: walletSigner, withAutoApprovals: withAutoApprovals })];
                case 7: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
var setOutputIsLoading = function (isLoadIng, paramsList) {
    paramsList.forEach(function (_a) {
        var param = _a.param;
        param.isLoading = isLoadIng;
    });
};
var setPluginApprovals = function (_a) {
    var plugin = _a.plugin, provider = _a.provider, walletSigner = _a.walletSigner;
    return __awaiter(void 0, void 0, void 0, function () {
        var requiredApprovals, vaultSigner, chainId, signer;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requiredApprovals = plugin.getRequiredApprovals(true);
                    vaultSigner = provider.signer;
                    if (!requiredApprovals || !requiredApprovals.length) {
                        return [2 /*return*/];
                    }
                    chainId = plugin.chainId;
                    return [4 /*yield*/, Promise.all(requiredApprovals.map(function (requiredApproval) { return __awaiter(void 0, void 0, void 0, function () {
                            var to, from, _a, approvePlugin, _b, spender, amount, walletSignerAddress, signer_1, method_1, _c, approveTo, tokenId, approve721, _d, operator_1, _approved, setApprovalForAll721, _e, operator, approved, setApprovalForAll1155;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0:
                                        to = requiredApproval.to, from = requiredApproval.from;
                                        _a = requiredApproval.protocol;
                                        switch (_a) {
                                            case 'ERC20': return [3 /*break*/, 1];
                                            case 'ERC721': return [3 /*break*/, 4];
                                            case 'ERC1155': return [3 /*break*/, 9];
                                        }
                                        return [3 /*break*/, 11];
                                    case 1:
                                        approvePlugin = new Approve({ chainId: plugin.chainId });
                                        _b = __read(requiredApproval.params, 2), spender = _b[0], amount = _b[1];
                                        return [4 /*yield*/, (walletSigner === null || walletSigner === void 0 ? void 0 : walletSigner.getAddress())];
                                    case 2:
                                        walletSignerAddress = ((_f.sent()) || '').toLowerCase();
                                        signer_1 = from && typeof from === 'string' && walletSignerAddress === from.toLowerCase()
                                            ? walletSigner
                                            : provider.signer;
                                        if (!signer_1)
                                            return [3 /*break*/, 12];
                                        if (typeof to !== 'string' || typeof spender !== 'string' || typeof amount !== 'string') {
                                            return [3 /*break*/, 12];
                                        }
                                        approvePlugin.input.set({
                                            to: to,
                                            methodParams: {
                                                spender: spender,
                                                amount: amount,
                                            },
                                        });
                                        return [4 /*yield*/, approvePlugin.getOutputValues({
                                                provider: {
                                                    provider: provider.provider,
                                                    signer: signer_1,
                                                },
                                                execute: true,
                                            })];
                                    case 3:
                                        _f.sent();
                                        return [3 /*break*/, 12];
                                    case 4:
                                        method_1 = requiredApproval.method;
                                        signer_1 = from ? walletSigner : vaultSigner;
                                        if (!signer_1)
                                            return [3 /*break*/, 12];
                                        if (!(method_1 === 'approve')) return [3 /*break*/, 6];
                                        _c = __read(requiredApproval.params, 2), approveTo = _c[0], tokenId = _c[1];
                                        if (typeof to !== 'string' || typeof approveTo !== 'string' || typeof tokenId !== 'string') {
                                            return [3 /*break*/, 12];
                                        }
                                        approve721 = new plugins.ERC721.actions.Approve({
                                            chainId: chainId,
                                            initParams: {
                                                to: requiredApproval.to,
                                                methodParams: {
                                                    to: approveTo,
                                                    tokenId: tokenId,
                                                },
                                            },
                                        });
                                        return [4 /*yield*/, approve721.getOutputValues({
                                                provider: {
                                                    provider: provider.provider,
                                                    signer: signer_1,
                                                },
                                                execute: true,
                                            })];
                                    case 5:
                                        _f.sent();
                                        return [3 /*break*/, 12];
                                    case 6:
                                        if (!(method_1 === 'setApprovalForAll')) return [3 /*break*/, 8];
                                        _d = __read(requiredApproval.params, 2), operator_1 = _d[0], _approved = _d[1];
                                        if (typeof to !== 'string' || typeof operator_1 !== 'string' || typeof _approved !== 'boolean') {
                                            return [3 /*break*/, 12];
                                        }
                                        setApprovalForAll721 = new plugins.ERC721.actions.SetApprovalForAll({
                                            chainId: chainId,
                                            initParams: {
                                                to: requiredApproval.to,
                                                methodParams: {
                                                    operator: operator_1,
                                                    _approved: _approved,
                                                },
                                            },
                                        });
                                        return [4 /*yield*/, setApprovalForAll721.getOutputValues({
                                                provider: {
                                                    provider: provider.provider,
                                                    signer: signer_1,
                                                },
                                                execute: true,
                                            })];
                                    case 7:
                                        _f.sent();
                                        return [3 /*break*/, 12];
                                    case 8: return [3 /*break*/, 12];
                                    case 9:
                                        _e = __read(requiredApproval.params, 2), operator = _e[0], approved = _e[1];
                                        if (typeof to !== 'string' || typeof operator !== 'string' || typeof approved !== 'boolean') {
                                            return [3 /*break*/, 12];
                                        }
                                        signer_1 = requiredApproval.from ? walletSigner : vaultSigner;
                                        if (!signer_1)
                                            return [3 /*break*/, 12];
                                        setApprovalForAll1155 = new plugins.ERC1155.actions.SetApprovalForAll({
                                            chainId: chainId,
                                            initParams: {
                                                to: requiredApproval.to,
                                                methodParams: {
                                                    operator: operator,
                                                    approved: approved,
                                                },
                                            },
                                        });
                                        return [4 /*yield*/, setApprovalForAll1155.getOutputValues({
                                                provider: {
                                                    provider: provider.provider,
                                                    signer: signer_1,
                                                },
                                                execute: true,
                                            })];
                                    case 10:
                                        _f.sent();
                                        return [3 /*break*/, 12];
                                    case 11: return [3 /*break*/, 12];
                                    case 12: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
};
var getSimpleAddLiquidityOutputValues = function (_a) {
    var plugin = _a.plugin, provider = _a.provider, execute = _a.execute;
    return __awaiter(void 0, void 0, void 0, function () {
        var chainId, libAddLiquidityPlugin, _b, AddLiquidity, AddLiquidityETH, addLiquidity, libAddLiquidityMethod, blockNumber, block, blockTimestamp, singerAddress, to, amountAParam, amountA, amountBParam, amountB, res, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    chainId = plugin.chainId;
                    libAddLiquidityPlugin = plugin;
                    _b = plugins.Uniswap.actions, AddLiquidity = _b.AddLiquidity, AddLiquidityETH = _b.AddLiquidityETH;
                    addLiquidity = undefined;
                    libAddLiquidityPlugin.create();
                    libAddLiquidityMethod = libAddLiquidityPlugin.input.methodParams.method.value;
                    return [4 /*yield*/, provider.provider.getBlockNumber()];
                case 1:
                    blockNumber = _c.sent();
                    return [4 /*yield*/, provider.provider.getBlock(blockNumber)];
                case 2:
                    block = _c.sent();
                    blockTimestamp = block.timestamp + 100;
                    return [4 /*yield*/, provider.signer.getAddress()];
                case 3:
                    singerAddress = _c.sent();
                    to = 'to' in libAddLiquidityPlugin.input.methodParams ? libAddLiquidityPlugin.input.methodParams.to.value : singerAddress;
                    amountAParam = libAddLiquidityPlugin.input.methodParams.amountADesired;
                    amountA = amountAParam.isVariable ? amountAParam.estimatedValue : amountAParam.value;
                    amountBParam = libAddLiquidityPlugin.input.methodParams.amountBDesired;
                    amountB = amountBParam.isVariable ? amountBParam.estimatedValue : amountBParam.value;
                    switch (libAddLiquidityMethod) {
                        case liquidity_method.addLiquidity:
                            addLiquidity = new AddLiquidity({
                                chainId: chainId,
                                initParams: {
                                    methodParams: {
                                        tokenA: libAddLiquidityPlugin.input.methodParams.tokenA.value,
                                        tokenB: libAddLiquidityPlugin.input.methodParams.tokenB.value,
                                        amountADesired: amountA,
                                        amountBDesired: amountB,
                                        amountAMin: '0',
                                        amountBMin: '0',
                                        to: to,
                                        deadline: String(blockTimestamp),
                                    },
                                },
                            });
                            break;
                        case liquidity_method.addLiquidityEthToken:
                            addLiquidity = new AddLiquidityETH({
                                chainId: chainId,
                                initParams: {
                                    value: libAddLiquidityPlugin.input.methodParams.amountADesired.value,
                                    methodParams: {
                                        token: libAddLiquidityPlugin.input.methodParams.tokenB.value,
                                        amountTokenDesired: amountB,
                                        amountTokenMin: '0',
                                        amountETHMin: '0',
                                        to: to,
                                        deadline: String(blockTimestamp),
                                    },
                                },
                            });
                            break;
                        case liquidity_method.addLiquidityTokenEth:
                            addLiquidity = new AddLiquidityETH({
                                chainId: chainId,
                                initParams: {
                                    value: libAddLiquidityPlugin.input.methodParams.amountBDesired.value,
                                    methodParams: {
                                        token: libAddLiquidityPlugin.input.methodParams.tokenA.value,
                                        amountTokenDesired: amountA,
                                        amountTokenMin: '0',
                                        amountETHMin: '0',
                                        to: to,
                                        deadline: String(blockTimestamp),
                                    },
                                },
                            });
                            break;
                        default:
                            break;
                    }
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    setOutputIsLoading(true, libAddLiquidityPlugin.output.paramsList);
                    return [4 /*yield*/, (addLiquidity === null || addLiquidity === void 0 ? void 0 : addLiquidity.getOutputValues({ provider: provider, execute: execute }))];
                case 5:
                    res = _c.sent();
                    libAddLiquidityPlugin.setError(undefined);
                    libAddLiquidityPlugin.currentGasLimit = addLiquidity === null || addLiquidity === void 0 ? void 0 : addLiquidity.currentGasLimit;
                    libAddLiquidityPlugin.output.params.amountA.setEstimated({
                        value: addLiquidity === null || addLiquidity === void 0 ? void 0 : addLiquidity.output.params.amountA.getEstimated(),
                    });
                    libAddLiquidityPlugin.output.params.amountB.setEstimated({
                        value: addLiquidity === null || addLiquidity === void 0 ? void 0 : addLiquidity.output.params.amountB.getEstimated(),
                    });
                    libAddLiquidityPlugin.output.params.liquidity.setEstimated({
                        value: addLiquidity === null || addLiquidity === void 0 ? void 0 : addLiquidity.output.params.liquidity.getEstimated(),
                    });
                    setOutputIsLoading(false, libAddLiquidityPlugin.output.paramsList);
                    return [2 /*return*/, res];
                case 6:
                    e_1 = _c.sent();
                    libAddLiquidityPlugin.setError(e_1.message);
                    libAddLiquidityPlugin.currentGasLimit = undefined;
                    libAddLiquidityPlugin.output.params.amountA.setEstimated({ value: undefined });
                    libAddLiquidityPlugin.output.params.amountB.setEstimated({ value: undefined });
                    libAddLiquidityPlugin.output.params.liquidity.setEstimated({ value: undefined });
                    setOutputIsLoading(false, libAddLiquidityPlugin.output.paramsList);
                    throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
};
var getSwapNoSlippageProtectionOutputValues = function (_a) {
    var plugin = _a.plugin, provider = _a.provider, execute = _a.execute;
    return __awaiter(void 0, void 0, void 0, function () {
        var chainId, libSwapPlugin, blockNumber, block, blockTimestamp, singerAddress, to, libSwapMethod, _b, UniswapV2SwapExactETHForTokens, UniswapV2SwapETHForExactTokens, UniswapV2SwapExactTokensForETH, UniswapV2SwapExactTokensForTokens, UniswapV2SwapTokensForExactETH, UniswapV2SwapTokensForExactTokens, swap, _c, amountIn, methodParams, amount, amountInVal, res, amountIn_1, amountOut, e_2, amountIn_2, amountOut;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    chainId = plugin.chainId;
                    libSwapPlugin = plugin;
                    return [4 /*yield*/, provider.provider.getBlockNumber()];
                case 1:
                    blockNumber = _d.sent();
                    return [4 /*yield*/, provider.provider.getBlock(blockNumber)];
                case 2:
                    block = _d.sent();
                    blockTimestamp = block.timestamp + 100;
                    return [4 /*yield*/, provider.signer.getAddress()];
                case 3:
                    singerAddress = _d.sent();
                    to = ('to' in libSwapPlugin.input.methodParams ? libSwapPlugin.input.methodParams.to.value : singerAddress);
                    libSwapMethod = libSwapPlugin.input.methodParams.method.value;
                    _b = plugins.Uniswap.actions, UniswapV2SwapExactETHForTokens = _b.UniswapV2SwapExactETHForTokens, UniswapV2SwapETHForExactTokens = _b.UniswapV2SwapETHForExactTokens, UniswapV2SwapExactTokensForETH = _b.UniswapV2SwapExactTokensForETH, UniswapV2SwapExactTokensForTokens = _b.UniswapV2SwapExactTokensForTokens, UniswapV2SwapTokensForExactETH = _b.UniswapV2SwapTokensForExactETH, UniswapV2SwapTokensForExactTokens = _b.UniswapV2SwapTokensForExactTokens;
                    swap = undefined;
                    _c = libSwapPlugin.input.params, amountIn = _c.amountIn, methodParams = _c.methodParams;
                    amount = (methodParams.amount.isVariable ? methodParams.amount.estimatedValue : methodParams.amount.value);
                    amountInVal = (amountIn.isVariable ? amountIn.estimatedValue : amountIn.value);
                    switch (libSwapMethod) {
                        case method.swapExactETHForTokens:
                            swap = new UniswapV2SwapExactETHForTokens({
                                chainId: chainId,
                                initParams: {
                                    value: amount,
                                    methodParams: {
                                        amountOutMin: '0',
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                        case method.swapETHForExactTokens:
                            swap = new UniswapV2SwapETHForExactTokens({
                                chainId: chainId,
                                initParams: {
                                    value: amountInVal,
                                    methodParams: {
                                        amountOut: amount,
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                        case method.swapExactTokensForETH:
                            swap = new UniswapV2SwapExactTokensForETH({
                                chainId: chainId,
                                initParams: {
                                    methodParams: {
                                        amountIn: amount,
                                        amountOutMin: '0',
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                        case method.swapExactTokensForTokens:
                            swap = new UniswapV2SwapExactTokensForTokens({
                                chainId: chainId,
                                initParams: {
                                    methodParams: {
                                        amountIn: amount,
                                        amountOutMin: '0',
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                        case method.swapTokensForExactTokens:
                            swap = new UniswapV2SwapTokensForExactTokens({
                                chainId: chainId,
                                initParams: {
                                    methodParams: {
                                        amountInMax: amountInVal,
                                        amountOut: amount,
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                        case method.swapTokensForExactETH:
                            swap = new UniswapV2SwapTokensForExactETH({
                                chainId: chainId,
                                initParams: {
                                    methodParams: {
                                        amountInMax: amountInVal,
                                        amountOut: amount,
                                        path: libSwapPlugin.input.methodParams.path.value,
                                        deadline: String(blockTimestamp),
                                        to: to,
                                    },
                                },
                            });
                            break;
                    }
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 6, , 7]);
                    setOutputIsLoading(true, libSwapPlugin.output.paramsList);
                    return [4 /*yield*/, (swap === null || swap === void 0 ? void 0 : swap.getOutputValues({ provider: provider, execute: execute }))];
                case 5:
                    res = _d.sent();
                    libSwapPlugin.setError(undefined);
                    libSwapPlugin.currentGasLimit = swap === null || swap === void 0 ? void 0 : swap.currentGasLimit;
                    amountIn_1 = libSwapPlugin.output.params.amountIn;
                    amountOut = libSwapPlugin.output.params.amountOut;
                    if (amountIn_1 instanceof FctParam && amountOut instanceof FctParam) {
                        amountIn_1.setEstimated({ value: swap === null || swap === void 0 ? void 0 : swap.output.params.amountIn.getEstimated() });
                        amountOut.setEstimated({ value: swap === null || swap === void 0 ? void 0 : swap.output.params.amountOut.getEstimated() });
                    }
                    setOutputIsLoading(false, libSwapPlugin.output.paramsList);
                    return [2 /*return*/, res];
                case 6:
                    e_2 = _d.sent();
                    libSwapPlugin.setError(e_2.message);
                    libSwapPlugin.currentGasLimit = undefined;
                    amountIn_2 = libSwapPlugin.output.params.amountIn;
                    amountOut = libSwapPlugin.output.params.amountOut;
                    if (amountIn_2 instanceof FctParam && amountOut instanceof FctParam) {
                        amountIn_2.setEstimated({ value: undefined });
                        amountOut.setEstimated({ value: undefined });
                    }
                    setOutputIsLoading(false, libSwapPlugin.output.paramsList);
                    throw e_2;
                case 7: return [2 /*return*/];
            }
        });
    });
};
